import { ShadowTypeTokens, } from '@voltmoney/schema';
export const shadowTypeTokensMap = {
    [ShadowTypeTokens.E1]: {
        shadowOffset: {
            width: 0,
            height: 1,
        },
        shadowOpacity: 0.2,
        shadowRadius: 2,
    },
    [ShadowTypeTokens.E2]: {
        shadowOffset: {
            width: 0,
            height: 1,
        },
        elevation: 2,
        shadowOpacity: 0.2,
        shadowRadius: 2,
    },
    [ShadowTypeTokens.E3]: {
        shadowOffset: {
            width: 0,
            height: 1,
        },
        shadowOpacity: 0.2,
        shadowRadius: 3,
    },
    [ShadowTypeTokens.E4]: {
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.2,
        shadowRadius: 3,
    },
    [ShadowTypeTokens.E5]: {
        shadowOffset: {
            width: 0,
            height: 4,
        },
        shadowOpacity: 0.2,
        shadowRadius: 4,
    },
    [ShadowTypeTokens.E6]: {
        shadowOffset: {
            width: 0,
            height: -1,
        },
        elevation: 10,
        shadowOpacity: 0.2,
        shadowRadius: 2,
    },
    [ShadowTypeTokens.E7]: {
        shadowOpacity: 0.08,
        elevation: 10,
        shadowOffset: {
            width: 5,
            height: 5,
        },
        shadowRadius: 10,
    },
};
